<div *ngIf="event$ | async as event" [class]="getClassByEvent('exceso-velocidad-nivel', 'Nivel I')"
  class="events-content" id="aside-map-events">
  <!-- <div class="first-container">
    <div class="title-container">
      <i class="pi pi-map"></i>
      <span
        >Titulo del fichero con variante de colo variante variante
        varianter</span
      >
    </div>

     <div
      style="
        width: 100px;
        height: 100px;
        background-color: var(--event-main-color);
      "
    ></div>

    <ul class="list-description">
      <li *ngFor="let item of items">
        <i class="pi pi-map"></i>
        <span>Descripción de la variante</span>
      </li>
    </ul>

    <div class="video-container">
      <hr class="separator" />

      <div class="image-container">
        <img
          src="https://cdn.hobbyconsolas.com/sites/navi.axelspringer.es/public/media/image/2024/11/arcane-4267056.jpg?tf=3840x"
          alt="image-example"
        />
      </div>
    </div>
  </div> -->
  <!--   <app-card-event-content
    [titleCard]="
      event.name_event_short !== null
        ? event.name_event_short.toLowerCase() == 'null'
          ? event.name_event_long
          : event.name_event_short
        : event.name_event_long
    "
    [classHeader]="getClassByEvent(event.type_event, event.name_event_long)"
    [eventName]="event.type_event"
  >
    <ul class="list-description">
      <app-item-event-content
        iconClass="fas fa-car"
        [label]="event.name_unit"
      ></app-item-event-content>
      <app-item-event-content
        iconClass="fas fa-user-circle"
        [label]="event.name_driver"
      ></app-item-event-content>
      <app-item-event-content
        iconClass="fas fa-crosshairs"
        [label]="event.longitude_event + '°, ' + event.latitude_event + '°'"
        [isTypeLink]="true"
        [href]="event.url_google_maps"
      ></app-item-event-content>
      <app-item-event-content
        iconClass="fas fa-shipping-fast"
        [label]="event.speed_unit + ' km/h'"
      ></app-item-event-content>
      <app-item-event-content
        iconClass="fas fa-tachometer-alt"
        [label]="event.limit_speed_unit + ' km/h'"
      ></app-item-event-content>
      <app-item-event-content
        iconClass="fas fa-clock"
        [label]="event.time_limit_infraction + ' horas'"
      ></app-item-event-content>
      <app-item-event-content
        iconClass="fas fa-road"
        [label]="event.geocerca === '' ? 'No detectado' : event.geocerca"
      ></app-item-event-content>
      <app-item-event-content
        iconClass="fas fa-map-marked-alt"
        [label]="event.reference_event"
      ></app-item-event-content>
      <app-item-event-content
        iconClass="fas fa-calendar-alt"
        [label]="event.date_event"
      ></app-item-event-content>
    </ul>

    <div *ngIf="event.componentRef !== null" class="video-container">
      <hr class="separator" />

      <div
        class="image-container"
        id="multimedia-aside-map-{{ event.id_event }}"
      >
      </div>
    </div>
  </app-card-event-content> -->

  <!-- Header con tipo de evento -->
  <div class="event-header">
    <div class="group-header" style="width: 100%">
      <span class="event-type-badge" [ngClass]="
          getClassByEvent(
            event.type_event,
            event.name_event_long,
            event.slug_event
          )
        ">
        {{
        fabricNameEvent(
        event.type_event,
        event.name_event_long,
        event.slug_event
        )
        }}
      </span>

      <span class="event-type-badge speed-variant" [ngClass]="getClassByEvent(event.type_event, event.name_event_long)">
        {{ (event.speed_unit || 0) + " km/h" }}
      </span>
    </div>
    <div class="group-header">

      <ng-container *ngIf="!(auxDisabled$ | async) && event?.canIdentifyDriverEvent">
        <ng-container *appHasPermission="'validate_event_driver'">
          <ng-container *ngIf="eventService.config.enableDriverIdentification">
            <button
              class="button-icon button-icon-close ml-2"
              (click)="findDriverAside()"
            >
              <mat-icon size="24">person_search</mat-icon>
            </button>
          </ng-container>
        </ng-container>
      </ng-container>
      <div *ngIf="!flagEventPopup" class="group-header" style="gap: 4px">
        <button (click)="previousEvent()" class="button-icon tooltipCustomBottom"
          data-tooltip="Ir al anterior evento (⌘←)">
          <!-- <svg width="16" height="16" fill="currentColor">
            <use xlink:href="./assets/icons/sprite.svg#arrowLeft"></use>
          </svg> -->
          <mat-icon size="16">arrow_back</mat-icon>
        </button>

        <button (click)="nextEvent()" class="button-icon tooltipCustomBottom" data-tooltip="Ir al siguiente evento (⌘→)">
          <!-- <svg width="16" height="16" fill="currentColor">
            <use xlink:href="./assets/icons/sprite.svg#arrowRight"></use>
          </svg> -->
          <mat-icon size="16">arrow_forward</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="main-section-cards position-relative" *ngIf="
      event.componentRef !== null &&
      (event.slug_event != 'checklist-daily' ||
        (event.slug_event == 'checklist-daily' &&
          checklistDetail?.clase === 'checklist-completed' || checklistDetail?.clase === 'checklist-no-completed'))
    ">
    <!-- Sección multimedia -->
    <app-card-event-content class="multimedia-section">
      <h4>
        <i class="fas fa-photo-video"></i>
        Multimedia
      </h4>
      <div class="video-container">
        <div class="image-container" id="multimedia-aside-map-{{ event.id_event }}"></div>
      </div>
    </app-card-event-content>
    <app-driver-identification-panel position="left"></app-driver-identification-panel>

  </div>
  <div class="aside-section-cards" [ngClass]="{ maximized: isMaximized$ | async }">
    <!-- Sección principal de detalles -->

    <app-card-event-content *ngIf="event.slug_event == 'checklist-daily'" class="main-details position-relative"
      style="min-height: 100px">
      <!-- ✅ Detalles del Checklist -->
      <ng-container *ngIf="checklistDetail">
        <h4>
          <i class="fas fa-info-circle"></i>
          Detalles del Checklist
        </h4>
        <div class="details-container">
          <app-item-event-content iconClass="fas fa-user" label="Registrado por"
            [value]="checklistDetail?.data?.driver || event.name_driver">
          </app-item-event-content>

          <app-item-event-content iconClass="fas fa-id-card" label="Código del conductor" [value]="
              checklistDetail?.data?.code_driver
                || event?.driverId
                || 'Sin información'
            ">
          </app-item-event-content>

          <app-item-event-content *ngIf="checklistDetail?.data?.date_check" iconClass="fas fa-calendar-check"
            label="Fecha del Checklist" [value]="
              checklistDetail?.data?.date_check
                ? (checklistDetail?.data?.date_check
                  | date : 'dd/MM/yyyy HH:mm')
                : 'Sin información'
            ">
          </app-item-event-content>

          <app-item-event-content iconClass="fas fa-check-circle" label="Estado del Checklist" [fromChecklist]="true"
            [withCheck]="checklistDetail?.data?.is_checked" [value]="
              checklistDetail?.data?.is_checked ? 'Completado' : 'No Completado'
            ">
          </app-item-event-content>
        </div>
      </ng-container>

      <!-- 🟡 Cargando -->
      <div *ngIf="!checklistDetail" class="overlay-loading">
        <div class="loading-message">
          <div class="spinner-border text-primary" role="status"></div>
          <p>Cargando checklist...</p>
        </div>
      </div>

      <!-- 🔴 Error -->
      <div *ngIf="checklistDetail?.clase === 'checklist-danger'" class="overlay-error">
        <div class="error-message text-center">
          <i class="bi bi-exclamation-triangle-fill text-danger fs-1"></i>
          <p class="text-danger mb-1">
            Ocurrió un error al cargar el checklist.
          </p>
        </div>
      </div>

      <!-- ⚪ Sin checklist -->
      <div *ngIf="checklistDetail?.clase === 'checklist-no-completed' && false" class="overlay-error">
        <div class="error-message text-center">
          <i class="bi bi-info-circle text-secondary fs-1"></i>
          <p class="text-muted">
            No se encontró ningún checklist para este vehículo.
          </p>
        </div>
      </div>
    </app-card-event-content>


    <app-card-event-content *ngIf="event.slug_event == 'checklist-interno'" class="main-details position-relative"
      style="min-height: 100px">
      <!-- ✅ Detalles del Checklist -->
      <ng-container *ngIf="internalChecklist">
        <h4>
          <i class="fas fa-info-circle"></i>
          Detalles del Checklist
        </h4>
        <div class="details-container">

          <!-- Datos del operador -->
          <app-item-event-content iconClass="fas fa-user" label="Nombre del Operador"
            [value]="internalChecklist.user?.nameEmployee">
          </app-item-event-content>

          <app-item-event-content iconClass="fas fa-id-badge" label="Tipo de Operador"
            [value]="internalChecklist.user?.type">
          </app-item-event-content>

          <!-- Datos del vehículo -->
          <app-item-event-content iconClass="fas fa-truck" label="Vehículo Evaluado"
            [value]="internalChecklist.checklist?.vehicle?.name">
          </app-item-event-content>


          <!-- Base -->
          <app-item-event-content iconClass="fas fa-map-marker-alt" label="Base"
            [value]="internalChecklist.checklist?.base?.name">
          </app-item-event-content>

          <!-- Turno -->
          <app-item-event-content iconClass="fas fa-clock" label="Turno" [value]="internalChecklist.checklist?.turno">
          </app-item-event-content>


          <!-- Observación -->
          <app-item-event-content iconClass="fas fa-comment" label="Observación"
            [value]="internalChecklist.checklist?.observation || '—'">
          </app-item-event-content>

          <!-- Fecha -->
          <app-item-event-content iconClass="fas fa-calendar-alt" label="Fecha Realizada"
            [value]="formatPeruDate(internalChecklist.checklist?.date)">
          </app-item-event-content>

        </div>
      </ng-container>
    </app-card-event-content>


    <app-card-event-content *ngIf="event.slug_event == 'checklist-interno'" class="main-details position-relative"
      style="min-height: 100px">
      <!-- ✅ Detalles del Checklist -->
      <ng-container *ngIf="internalChecklist">
        <h4>
          <i class="fas fa-info-circle"></i>
          Criterios Marcados
        </h4>
        <div class="details-container">

          <ng-container *ngFor="let item of internalChecklist.checklist?.criteria">
            <app-item-event-content *ngIf="item.selectedState?.name" iconClass="fas fa-check-circle"
              [label]="item.label + (item.required ? ' *' : '')" [value]="item.selectedState?.name">
            </app-item-event-content>
          </ng-container>
        </div>
      </ng-container>
    </app-card-event-content>

    <app-card-event-content class="main-details">
      <h4>
        <i class="fas fa-info-circle"></i>
        Detalle del evento
      </h4>

      <!-- Información crítica destacada -->
      <div *ngIf="flagEventPopup && !(isMaximized$ | async)" class="critical-info">
        <div class="info-card">
          <span class="value">{{ event.speed_unit }}</span>
          <span class="label">km/h</span>
          <button (click)="copyValue($event, event.speed_unit)">
            <i class="fas fa-copy copy-icon"></i>
          </button>
        </div>
        <div class="info-card">
          <span class="value">{{ event.name_unit }}</span>
          <span class="label">Vehículo</span>
          <button (click)="copyValue($event, event.name_unit)">
            <i class="fas fa-copy copy-icon"></i>
          </button>
        </div>
      </div>

      <!-- Lista de detalles -->
      <div class="details-container">
        <ul class="list-description">
          <app-item-event-content *ngIf="event.name_unit !== undefined" iconClass="fas fa-car" label="Vehículo"
            [value]="event.name_unit"></app-item-event-content>
          <app-item-event-content *ngIf="event.name_driver !== undefined" iconClass="fas fa-user-circle"
            label="Conductor" [value]="
              event.slug_event === 'checklist-daily' &&
              checklistDetail?.data?.driver
                ? checklistDetail?.data?.driver
                : event.name_driver
            "></app-item-event-content>
          <app-item-event-content *ngIf="event.luminaria !== undefined" iconClass="fas fa-lightbulb" label="Luminaria"
            [value]="event.luminaria"></app-item-event-content>
          <app-item-event-content *ngIf="event.longitude_event !== undefined" iconClass="fas fa-crosshairs"
            label="Coordenadas" [value]="event.latitude_event + '°, ' + event.longitude_event + '°'" [isTypeLink]="true"
            [href]="event.url_google_maps" style="text-wrap: nowrap"></app-item-event-content>
          <app-item-event-content *ngIf="event.last_maintenance !== undefined" iconClass="fas fa-crosshairs"
            label="Último mantenimiento" [value]="event.last_maintenance"></app-item-event-content>
          <app-item-event-content *ngIf="event.hours_passed !== undefined" iconClass="fas fa-crosshairs"
            label="Horas transcurridas" [value]="event.hours_passed"></app-item-event-content>
          <app-item-event-content *ngIf="event.hours_remaining !== undefined" iconClass="fas fa-crosshairs"
            label="Horas restantes" [value]="event.hours_remaining"></app-item-event-content>
          <app-item-event-content *ngIf="event.odometer !== undefined" iconClass="fas fa-crosshairs" label="Odómetro"
            [value]="event.odometer"></app-item-event-content>
          <app-item-event-content *ngIf="event.rpm !== undefined" iconClass="fas fa-tachometer-alt" label="RPM"
            [value]="event.rpm"></app-item-event-content>
          <app-item-event-content *ngIf="event.voltage !== undefined" iconClass="fas fa-crosshairs" label="Voltaje"
            [value]="event.voltage + ' V'"></app-item-event-content>
          <app-item-event-content *ngIf="event.speed_unit !== undefined" iconClass="fas fa-shipping-fast"
            label="Velocidad" [value]="event.speed_unit + ' km/h'"></app-item-event-content>

          <app-item-event-content *ngIf="
              event.slug_event == 'movimiento-en-fechas-no-autorizadas'" iconClass="fas fa-calendar-alt" label="Fecha no Autorizada"
            [value]="event.fecha_no_autorizada ? (event.fecha_no_autorizada | date : 'yyyy/MM/dd') : 'Sin información'"></app-item-event-content>

          <app-item-event-content *ngIf="
              event.slug_event == 'exceso-velocidad-duracion-direccion' &&
              detailVelocityEvent?.seconds != null
            " iconClass="fas fa-clock" label="Duración"
            [value]="getDurationText(detailVelocityEvent.seconds)"></app-item-event-content>


          <app-item-event-content *ngIf="event.limit_speed_unit !== undefined" iconClass="fas fa-tachometer-alt"
            label="Velocidad máxima" [value]="event.limit_speed_unit + ' km/h'"></app-item-event-content>
          <app-item-event-content *ngIf="event.time_limit_infraction !== undefined" iconClass="fas fa-clock"
            label="Tiempo límite de infracción"
            [value]="event.time_limit_infraction + ' horas'"></app-item-event-content>
          <app-item-event-content *ngIf="event.time_tolerance !== undefined" iconClass="fas fa-hourglass-end"
            label="Tiempo de tolerancia" [value]="formatTimeWithUnit(event.time_tolerance)"></app-item-event-content>
          <app-item-event-content *ngIf="event.time_estadia !== undefined" iconClass="fas fa-hourglass-half"
            label="Tiempo de estadía" [value]="formatTimeWithUnit(event.time_estadia)"></app-item-event-content>
          <app-item-event-content *ngIf="event.geocerca !== undefined" iconClass="fas fa-road" label="Geocerca (Zona)"
            [value]="event.geocerca === '' ? 'No detectado' : event.geocerca"></app-item-event-content>

          <app-item-event-content *ngIf="
              event.slug_event == 'exceso-velocidad-duracion-direccion' &&
              detailVelocityEvent?.geoMaxVel != null
            " iconClass="fas fa-tachometer-alt" label="Velocidad Máx. Geocerca"
            [value]="detailVelocityEvent.geoMaxVel + ' km/h'"></app-item-event-content>


          <app-item-event-content *ngIf="event.slug_event == 'multi-humedad' && event.sensor !== undefined" iconClass="fas fa-cloud"
            label="Sensor de Humedad" [value]="event.sensor"></app-item-event-content>
          <app-item-event-content *ngIf="event.slug_event == 'multi-temperatura' && event.sensor !== undefined" iconClass="fas fa-temperature-low"
            label="Sensor de Temperatura" [value]="event.sensor"></app-item-event-content>
          <app-item-event-content *ngIf="event.slug_event == 'multi-humedad' && event.valor !== undefined" iconClass="fas fa-cloud"
            label="Valor de Humedad" [value]="event.valor"></app-item-event-content>
          <app-item-event-content *ngIf="event.slug_event == 'multi-temperatura' && event.valor !== undefined" iconClass="fas fa-temperature-low"
            label="Valor de Temperatura" [value]="event.valor"></app-item-event-content>
          <app-item-event-content *ngIf="event.slug_event == 'multi-humedad' && event.valorLimite !== undefined" iconClass="fas fa-cloud"
            label="Limite de Humedad" [value]="event.valorLimite"></app-item-event-content>
          <app-item-event-content *ngIf="event.slug_event == 'multi-temperatura' && event.valorLimite !== undefined" iconClass="fas fa-temperature-low"
            label="Limite de Temperatura" [value]="event.valorLimite"></app-item-event-content>
          <app-item-event-content *ngIf="event.reference_event !== undefined" iconClass="fas fa-map-marked-alt"
            label="Referencia" [value]="event.reference_event"></app-item-event-content>
          <app-item-event-content *ngIf="event.alcohol_level !== undefined" iconClass="fas fa-glass-whiskey"
            label="Nivel de alcohol" [value]="event.alcohol_level + ' mg/L'"></app-item-event-content>
          <app-item-event-content *ngIf="
              event.status_camera !== undefined &&
              event.type_event === 'error-de-camara-360'
            " iconClass="fas fa-camera" label="Motivo" [value]="event.status_camera"></app-item-event-content>
          <app-item-event-content *ngIf="
              event.status_system_error !== undefined &&
              event.type_event === 'error-sistema-360'
            " iconClass="fas fa-times-circle" label="Estado"
            [value]="event.status_system_error"></app-item-event-content>
          <app-item-event-content *ngIf="
              event.status_system_ok !== undefined &&
              event.type_event === 'sistema-ok-360'
            " iconClass="fas fa-check-circle" label="Estado" [value]="event.status_system_ok"></app-item-event-content>
          <app-item-event-content *ngIf="
              event.status_system_boot_failure !== undefined &&
              event.type_event === 'fallo-inicio-del-sistema-360'
            " iconClass="fas fa-times-circle" label="Estado"
            [value]="event.status_system_boot_failure"></app-item-event-content>


          <ng-container *ngIf="event.slug_event != 'exceso-velocidad-duracion-direccion'">
            <app-item-event-content *ngIf="event.date_event !== undefined" iconClass="fas fa-calendar-alt" label="Fecha"
              [value]="event.date_event"></app-item-event-content>
          </ng-container>


          <app-item-event-content *ngIf="
              event.slug_event == 'exceso-velocidad-duracion-direccion' &&
              detailVelocityEvent?.timeInit
            " iconClass="fas fa-calendar-alt" label="Fecha desde"
            [value]="detailVelocityEvent.timeInit"></app-item-event-content>


          <app-item-event-content *ngIf="
              event.slug_event == 'exceso-velocidad-duracion-direccion' &&
              detailVelocityEvent?.timeEnd
            " iconClass="fas fa-calendar-alt" label="Fecha hasta"
            [value]="detailVelocityEvent.timeEnd"></app-item-event-content>

          <app-item-event-content *ngIf="event.server_date !== undefined" iconClass="fas fa-clock"
            label="Fecha servidor" [value]="event.server_date"></app-item-event-content>



          <ng-container *ngFor="let temperatura of event.temperaturas">
            <ng-container *ngIf="temperatura.sensor">
              <app-item-event-content *ngIf="temperatura.temperatura !== undefined"
                iconClass="fas fa-thermometer-quarter" [label]="'Sensor '+temperatura.sensor"
                [value]="temperatura.temperatura | number:'1.1-1'"></app-item-event-content>
            </ng-container>
          </ng-container>

          <app-item-event-content *ngIf="event.temperatura_max !== undefined" iconClass="fas fa-temperature-high"
            label="Temperatura Máxima" [value]="event.temperatura_max"></app-item-event-content>
          <app-item-event-content *ngIf="event.temperatura_min !== undefined" iconClass="fas fa-temperature-low"
            label="Temperatura Mínima" [value]="event.temperatura_min"></app-item-event-content>

          <ng-container *ngFor="let humedad of event.humedades">
            <ng-container *ngIf="humedad.sensor">
              <app-item-event-content *ngIf="humedad.humedad !== undefined" iconClass="fas fa-cloud"
                [label]="'Sensor '+humedad.sensor" [value]="humedad.humedad | number:'1.1-1'"></app-item-event-content>
            </ng-container>
          </ng-container>

          <app-item-event-content *ngIf="event.humedad_max !== undefined" iconClass="fas fa-cloud-upload-alt"
            label="Humedad Máxima" [value]="event.humedad_max"></app-item-event-content>
          <app-item-event-content *ngIf="event.humedad_min !== undefined" iconClass="fas fa-cloud-download-alt"
            label="Humedad Mínima" [value]="event.humedad_min"></app-item-event-content>
        </ul>
      </div>
    </app-card-event-content>

    <!-- Sección formulario -->

    <app-card-event-content *ngIf="
        event.hasEventForm && !flagEventPopup && !(errorServer$ | async);
        else errorForm
      " class="form-section">
      <h4>
        <i class="fas fa-edit"></i>
        Atención del evento
      </h4>
      <form class="event-form">
        <!-- <div class="form-group">
        <label>Fecha</label>
        <input
          type="text"
          readonly
          [value]="event.date_event"
          autocomplete="off"
        />
      </div>
      <div class="form-group">
        <label>Nombre</label>
        <input
          type="text"
          readonly
          [value]="event.name_unit"
          autocomplete="off"
        />
      </div>
      <div class="form-group">
        <label>Tipo Evento</label>
        <input
          type="text"
          readonly
          [value]="event.name_event_long"
          autocomplete="off"
        />
      </div> -->

        <!-- SELECCIONAR DRIVER INDENTIFICATION -->
        <ng-container *ngIf="!(auxDisabled$ | async) && event?.canIdentifyDriverEvent">
          <ng-container *appHasPermission="'validate_event_driver'">
            <ng-container *ngIf="eventService.config.enableDriverIdentification">
              <div class="form-group">
                <label>Posible Conductor</label>
                <div style="width: 70%; overflow: hidden">
                  <p-dropdown [panelStyle]="{
                      'font-size': '10px',
                      'border-radius': '4px',
                      border: '1px solid #00000011'
                    }" [style]="{
                      width: '100%',
                      'font-size': '10px',
                      border: '1px solid #00000011',
                      'border-radius': '4px'
                    }" [appendTo]="'body'" [options]="
                      driversList
                    " filter="true" placeholder="Selecciona un posible conductor"
                    optionLabel="nombre_conductor" optionValue="id" [(ngModel)]="driverIdentificationId"
                    (onChange)="onDriverIdentificationChange($event.value)" name="driverIdentificationId"
                    filterBy="nombre_conductor" emptyMessage="No se encontraron registros"
                    emptyFilterMessage="No se han encontrado resultados"></p-dropdown>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>

        <!-- DRIVER INDENTIFICATION -->
        <ng-container *ngIf="!(auxDisabled$ | async) && event?.event_driverId != 0 && event?.canIdentifyDriverEvent">
          <ng-container *appHasPermission="'validate_event_driver'">
            <ng-container *ngIf="eventService.config.enableDriverIdentification">
              <div class="form-group" *ngIf="event?.event_driverId && event?.event_driverId !== 0">
                <label class="col-12">Conductor del Evento Validado</label>
                <div class="d-flex col-12 flex-column gap-1">
                  <label class="custom-checkbox col-12">
                    <input
                      type="checkbox"
                      [checked]="(driverIdIdentification$ | async) == event.event_driverId"
                      (click)="onCheckboxClick(event.event_driverId, $event)"
                    >
                    <span class="checkmark">
                      <i class="fas fa-check"></i>
                    </span>
                  </label>

                  <small class="text-danger" *ngIf="showDriverWarning">
                    El evento no tiene un conductor identificado
                  </small>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>



        <!-- CRITERIA -->
        <div [ngClass]="{
            error_border:
              (isActiveObservation && errorObservation.status) ||
              (isActiveCriteria && errorCriteria.status),
            accurate_border:
              (isActiveObservation && !errorObservation.status) ||
              (isActiveCriteria && !errorCriteria.status)
          }">
          <div *ngIf="errorCriteria.status && errorObservation.status" class="errorMessage">
            {{ errorCriteria.message }}
          </div>
          <div class="form-group">
            <label>Criterio de Evaluación</label>
            <div style="width: 70%; overflow: hidden" [ngClass]="{ 'material-container': auxDisabled$ | async }">
              <div *ngIf="(auxDisabled$ | async) !== true">
                <p-dropdown *ngIf="isCriteria" [panelStyle]="{
                    'font-size': '10px',
                    'border-radius': '4px',
                    border: '1px solid #00000011'
                  }" [style]="{
                    width: '100%',
                    'font-size': '10px',
                    border: '1px solid #00000011',
                    'border-radius': '4px'
                  }" [appendTo]="'body'" [options]="
                    normalizeArrayEvaluations(event.evaluations_criteria_filter)
                  " placeholder="Selecciona un criterio" [group]="
                    this.evaluationsAux[0]?.tipo_evento
                      ? this.evaluationsAux[0].tipo_evento == 'Posible Fatiga'
                      : false
                  " filterBy="label" emptyMessage="No se encontraron registros"
                  emptyFilterMessage="No se han encontrado resultados" filterMatchMode="contains"
                  (onChange)="criteriaSelected($event)" [disabled]="auxDisabled$ | async" [(ngModel)]="criteria_input"
                  (ngModelChange)="onCriteriaChange()" #criteriaInput name="inputCriteria"></p-dropdown>
                <div *ngIf="!isCriteria" class="empty_criteria">
                  No hay criterios
                </div>
              </div>
              <div *ngIf="auxDisabled$ | async">
                <input class="input_complete" type="text" readonly
                  [value]="(valueInputsDisabled$ | async)?.criteria_name" autocomplete="off" />
              </div>
            </div>
          </div>
        </div>
        <!-- URL -->
        <div *ngIf="
            isConfirmedEvaluation ||
            ((auxDisabled$ | async) &&
              (valueInputsDisabled$ | async)?.url_video &&
              (valueInputsDisabled$ | async)?.url_video.trim() !== '')
          " [ngClass]="{
            error_border: isActiveUrl && errorUrl.status,
            accurate_border: isActiveUrl && !errorUrl.status
          }">
          <div *ngIf="errorUrl.status" class="errorMessage">
            {{ errorUrl.message }}
          </div>
          <div class="form-group">
            <label>Identificar Video</label>
            <input *ngIf="(auxDisabled$ | async) !== true" type="text" placeholder="Ingrese la url" autocomplete="off"
              [disabled]="auxDisabled$ | async" [(ngModel)]="urlvideo_input" (ngModelChange)="onUrlChange()"
              name="inputUrlVideo" />
            <input *ngIf="
                (auxDisabled$ | async) &&
                (valueInputsDisabled$ | async)?.url_video &&
                (valueInputsDisabled$ | async)?.url_video.trim() !== ''
              " type="text" readonly [value]="(valueInputsDisabled$ | async)?.url_video" autocomplete="off" />
          </div>
        </div>

        <!-- CALIFICATION -->
        <div *ngIf="
            isConfirmedEvaluation ||
            ((auxDisabled$ | async) &&
              valueRaiting !== null &&
              valueRaiting?.toString() !== '0')
          " [ngClass]="{
            error_border: isActiveCalification && errorCalification.status,
            accurate_border: isActiveCalification && !errorCalification.status
          }">
          <div *ngIf="errorCalification.status" class="errorMessage">
            {{ errorCalification.message }}
          </div>
          <div class="form-group">
            <label>Calificación</label>
            <div class="rating_container">
              <p-rating *ngIf="(auxDisabled$ | async) !== true" [(ngModel)]="calification_input"
                (ngModelChange)="onCalificationChange()" name="ratingCalification" [cancel]="false"
                [disabled]="auxDisabled$ | async"></p-rating>
              <p-rating *ngIf="
                  (auxDisabled$ | async) &&
                  valueRaiting !== null &&
                  valueRaiting?.toString() !== '0'
                " [(ngModel)]="valueRaiting" name="ratingCalificationDisabled" [cancel]="false"
                [disabled]="true"></p-rating>
              <div *ngIf="isActiveCalification && !errorCalification.status" class="check">
                <i class="pi pi-check"></i>
              </div>
            </div>
          </div>
        </div>

        <!-- OBSERVATION -->
        <div [ngClass]="{
            error_border:
              (isActiveObservation && errorObservation.status) ||
              (isActiveCriteria && errorCriteria.status),
            accurate_border:
              (isActiveObservation && !errorObservation.status) ||
              (isActiveCriteria && !errorCriteria.status)
          }">
          <!-- <div>
            isAcitveObservation: {{ isActiveObservation }} isActiveCriteria:
            {{ isActiveCriteria }} errorObservation:
            {{ errorObservation.status }} errorCriteria:
            {{ errorCriteria.status }}
          </div> -->
          <div *ngIf="errorObservation.status && errorCriteria.status" class="errorMessage">
            {{ errorObservation.message }}
          </div>
          <div class="form-group">
            <label>Observación</label>
            <input *ngIf="(auxDisabled$ | async) !== true" #observationInput type="text"
              placeholder="Ingrese un comentario" autocomplete="off" [disabled]="auxDisabled$ | async"
              [(ngModel)]="observation_input" (ngModelChange)="onObservationChange()"
              (onBlur)="disableActiveObservation()" name="inputObservation" list="observationsList" />
            <datalist id="observationsList">
              <option *ngFor="let obs of observations" [value]="obs"></option>
            </datalist>
            <textareariem *ngIf="auxDisabled$ | async" class="auto-resize-textarea">{{ (valueInputsDisabled$ |
              async)?.observation }}</textareariem>
          </div>
        </div>

        <!-- OPERATOR -->
        <div [ngClass]="{
            error_border: isActiveOperator && errorOperator.status,
            accurate_border: isActiveOperator && !errorOperator.status
          }">
          <div *ngIf="errorOperator.status" class="errorMessage">
            {{ errorOperator.message }}
          </div>
          <div class="form-group">
            <label>Responsable</label>
            <div style="width: 70%; overflow: hidden">
              <p-dropdown *ngIf="(auxDisabled$ | async) !== true" [panelStyle]="{
                  'font-size': '10px',
                  'border-radius': '4px',
                  border: '1px solid #00000011'
                }" [style]="{
                  width: '100%',
                  'font-size': '10px',
                  border: '1px solid #00000011',
                  'border-radius': '4px'
                }" [appendTo]="'body'" [options]="event.operators" placeholder="Selecciona un operador" editable="true"
                [group]="true" emptyMessage="Lista de Operadores vacía." [disabled]="auxDisabled$ | async"
                [(ngModel)]="operator_name_input" name="inputOperatorName" (ngModelChange)="onOperatorChange()">
              </p-dropdown>
              <input *ngIf="auxDisabled$ | async" class="input_complete" type="text" readonly
                [value]="(valueInputsDisabled$ | async)?.operator_name" autocomplete="off" />
            </div>
          </div>
        </div>

        <!-- WHATSAPP -->
        <div *ngIf="(auxDisabled$ | async) !== true && iCanSeeWhatsappSending()" class="form-group checkbox-group">
          <p-checkbox class="fix_check checkbox-dual" [(ngModel)]="sendEvaluationByWhatsapp"
            (onChange)="submitSendEvaluationByWhatsappEmitter()" name="sendEvaluationByWhatsapp"
            [binary]="true"></p-checkbox>
          <label for="sendEvaluationByWhatsapp">Enviar evento evaluado por whatsapp</label>
        </div>

        <!-- EXTERNAL -->
        <!-- <div
          *ngIf="(auxDisabled$ | async) !== true && iCanSeeExternalSending()"
          class="form-group checkbox-group"
        >
          <p-checkbox
            class="fix_check checkbox-dual"
            [(ngModel)]="sendExternal"
            (onChange)="submitSendExternalEmitter()"
            name="sendExternal"
            [binary]="true"
          ></p-checkbox>
          <label for="sendExternal">Enviar evento evaluado a APV</label>
        </div> -->

        <!-- CHECKBOX -->
        <div *ngIf="checkListEventsByType(event.type_event)" class="form-group checkbox-group">
          <p-triStateCheckbox *ngIf="(auxDisabled$ | async) !== true" class="fix_check" [(ngModel)]="radioValue"
            name="radioCommunication" [readonly]="event.evaluations.id" (onChange)="msmOfTxRadialChange($event)"
            [disabled]="auxDisabled$ | async"></p-triStateCheckbox>
          <label *ngIf="(auxDisabled$ | async) !== true" for="radioCommunication">Comunicación radial: <span>{{
              msmOfTxRadial }}</span></label>

          <p-triStateCheckbox *ngIf="auxDisabled$ | async" class="fix_check"
            [ngModel]="(valueInputsDisabled$ | async)?.comunication" name="radioCommunication" [readonly]="true"
            [disabled]="auxDisabled$ | async"></p-triStateCheckbox>
          <label *ngIf="auxDisabled$ | async" for="confirmacion">Comunicación radial:
            <span>{{
              msmOfTxRadialSelect((valueInputsDisabled$ | async)?.comunication)
              }}</span></label>
        </div>

        <!-- RESPONSE WHATSAPP SERVICE -->
        <div *ngIf="
            (auxDisabled$ | async) &&
            (messagesSentByWhatsApp$ | async) &&
            variantMessage !== 'loading' &&
            whatsappsSendingMessage.length > 0
          ">
          <div [ngSwitch]="variantMessage" class="form-group">
            <p *ngSwitchCase="'success'" class="success">
              <i class="fas fa-check"></i>
              {{ whatsappsSendingMessage }}
            </p>
            <p *ngSwitchCase="'error'" class="error">
              <i class="fas fa-times"></i>
              {{ whatsappsSendingMessage }}
            </p>
            <p *ngSwitchCase="'warning'" class="warning">
              <i class="fas fa-exclamation-triangle"></i>
              {{ whatsappsSendingMessage }}
            </p>
            <p *ngSwitchDefault></p>
          </div>
        </div>

        <div *ngIf="
            variantMessage === 'loading' &&
            !(isLoading$ | async) &&
            iCanSeeWhatsappSending() &&
            sendEvaluationByWhatsapp
          " class="form-group">
          <p class="loadingMessage">
            <i class="fas fa-spinner fa-spin"></i>
            Enviando mensaje...
          </p>
        </div>

        <!-- BUTTONS -->
        <div class="form-buttons">
          <button *ngIf="(auxDisabled$ | async) !== true && !(isLoading$ | async)" type="button" class="secondary"
            (click)="clearForm()" [disabled]="auxDisabled$ | async">
            Limpiar formulario
          </button>
          <button *ngIf="(auxDisabled$ | async) !== true && !(isLoading$ | async)" type="button" class="primary"
            (click)="submitEvaluation(event)" [disabled]="auxDisabled$ | async">
            Guardar
          </button>

          <div *ngIf="isLoading$ | async" class="loading">
            <p-progressBar mode="indeterminate"></p-progressBar>
          </div>

          <div *ngIf="auxDisabled$ | async" class="complete-form">
            <div class="empty_criteria v2">
              ¡Formulario completado con éxito!
            </div>
            <button (click)="nextEvent()" class="button-icon button-icon-v2 tooltipCustom"
              data-tooltip="Ir al siguiente evento (⌘→)" style="display: flex">
              <!-- <svg width="20" height="20" fill="currentColor">
                <use xlink:href="./assets/icons/sprite.svg#arrowRight"></use>
              </svg> -->
              <mat-icon size="20">arrow_forward</mat-icon>
            </button>
          </div>
        </div>
      </form>
    </app-card-event-content>

    <ng-template #errorForm>
      <app-card-event-content *ngIf="errorServer$ | async">
        <h4>
          <i class="fas fa-exclamation-triangle"></i>
          Esperando respuesta del servidor, 1 minuto
        </h4>
      </app-card-event-content>
    </ng-template>
  </div>
</div>
